import { useNationality } from "@faire/deprecated-retailer-visitor-shared/hooks/retailer/useNationality";
import { useIsLoggedInRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import { getSessionCountry } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getSessionCountry";
import supportArticle, {
  QueryParameters,
} from "@faire/web-api--source/routes/www/support/articles/articleId";
import { THREE_LETTER_EUROPE_SUPPORTED_COUNTRIES } from "@faire/web/common/consts/THREE_LETTER_EUROPE_SUPPORTED_COUNTRIES";
import { THREE_LETTER_PRIMARY_COUNTRY_CODES } from "@faire/web/common/consts/THREE_LETTER_PRIMARY_COUNTRY_CODES";

const INSIDER_USA_HELP_CENTER_ARTICLE_ID = "4406840862747";
const INSIDER_EUROPE_HELP_CENTER_ARTICLE_ID = "4418050425115";
const INSIDER_AUSTRALIA_HELP_CENTER_ARTICLE_ID = "29367193374747";
const INSIDER_CANADIAN_HELP_CENTER_ARTICLE_ID = "29655338268315";

export const useInsiderHelpCenterArticleLink = (
  queryParams?: Partial<QueryParameters>
) => {
  const isLoggedIn = useIsLoggedInRetailer();
  const loggedInSupportUrl = useInsiderHelpCenterURL();
  const loggedOutSupportUrl = useLoggedOutInsiderHelpCenterUrl();

  // User's country is computed differently between logged in and logged out, since for logged out we are basing it only on ip address.
  // Help center article link is different for each country.
  const supportUrl = isLoggedIn ? loggedInSupportUrl : loggedOutSupportUrl;

  return supportArticle(supportUrl, queryParams);
};

const useInsiderHelpCenterURL = () => {
  const { isAmerican, isAustralian, isEurope, isCanadian } = useNationality();

  if (isCanadian) {
    return INSIDER_CANADIAN_HELP_CENTER_ARTICLE_ID;
  }

  if (isAmerican) {
    return INSIDER_USA_HELP_CENTER_ARTICLE_ID;
  }
  if (isEurope) {
    return INSIDER_EUROPE_HELP_CENTER_ARTICLE_ID;
  }
  if (isAustralian) {
    return INSIDER_AUSTRALIA_HELP_CENTER_ARTICLE_ID;
  }
  return INSIDER_USA_HELP_CENTER_ARTICLE_ID;
};

// If logged out, we need to use the session country instead of useNationality.
// Since when logged out we dont have access to the retailer and useNationality depends on it.
const useLoggedOutInsiderHelpCenterUrl = () => {
  const sessionCountry = getSessionCountry();

  if (sessionCountry === THREE_LETTER_PRIMARY_COUNTRY_CODES.CAN) {
    return INSIDER_CANADIAN_HELP_CENTER_ARTICLE_ID;
  }

  if (sessionCountry === THREE_LETTER_PRIMARY_COUNTRY_CODES.AUS) {
    return INSIDER_AUSTRALIA_HELP_CENTER_ARTICLE_ID;
  }

  const isEurope = THREE_LETTER_EUROPE_SUPPORTED_COUNTRIES.includes(
    sessionCountry as (typeof THREE_LETTER_EUROPE_SUPPORTED_COUNTRIES)[number]
  );

  if (isEurope) {
    return INSIDER_EUROPE_HELP_CENTER_ARTICLE_ID;
  }

  return INSIDER_USA_HELP_CENTER_ARTICLE_ID;
};

export const useCancelInsiderMembershipHelpCenterArticleSectionAnchor = () => {
  const { isAmerican, isAustralian, isEurope, isCanadian } = useNationality();

  if (isAmerican || isCanadian) {
    return "11";
  }
  if (isEurope) {
    return "10";
  }
  if (isAustralian) {
    return "9";
  }
  return undefined;
};
